export default httpClient => ({
    save: async ({dados, token}) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/categorias-lojas', dados, { headers });
        console.log(dados)
        return {
            data: response.data
        }
    },
    update: async ({dados, token}) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/categorias-lojas/' + dados.get('id'), dados, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/categorias-lojas/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/categorias-lojas', { headers });
        return {
            data: response.data
        }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/categorias-lojas/' + id, { headers });
        return {
            data: response
        }
    },
    deletarImagem: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/deletar-imagem/' + id, { headers });
        return {
            data: response
        }
    },
});